(() => {
  const tabs = Array.from(document.querySelectorAll('.docs__tab'));
  const labels = Array.from(document.querySelectorAll('.docs__label'));
  const tabPanels = Array.from(document.querySelectorAll('.docs__tabpanel'));
  const details = document.querySelector('.docs__details');
  const url = new URL(window.location);
  const tabId = url.searchParams.get('t');

  let currentTab = null;

  /* The details widget must be open to be visible on desktop because the toggle is hidden */
  const toggleDetails = matchMedia('(min-width: 768px)');

  const setSelectedText = (tab) => {
    const selected = document.querySelector('.docs__selected');
    if (!selected) return;

    const label = labels.find((l) => l.htmlFor === tab.id);
    if (!label) return;

    selected.textContent = label.textContent;
  };

  const setAriaSelected = (tab) => {
    tabs.forEach((t) => {
      t.setAttribute('aria-selected', 'false');
    });
    tab.setAttribute('aria-selected', 'true');
  };

  const showPanel = (tab) => {
    const tabTarget = tab.getAttribute('aria-controls');
    if (!tabTarget) return;

    const panel = tabPanels.find((p) => p.id === tabTarget);
    if (!panel) return;

    tabPanels.forEach((p) => {
      p.setAttribute('aria-hidden', 'true');
      p.setAttribute('inert', '');
      p.classList.remove('active');
    });
    panel.setAttribute('aria-hidden', 'false');
    panel.removeAttribute('inert');
    panel.classList.add('active');
  };

  const setActiveTab = (id) => {
    if (currentTab && id === currentTab.id) return;

    const tab = tabs.find((t) => t.id === id);
    if (!tab) return;

    setSelectedText(tab);
    setAriaSelected(tab);
    tabs.forEach((t) => {
      /* eslint-disable-next-line */
      t.checked = t.id === id;
    });
    showPanel(tab);
    if (!toggleDetails.matches) {
      details.removeAttribute('open');
    }
    currentTab = id;
  };

  const toggleDetailsHandler = (e) => {
    if (e.matches) {
      details.setAttribute('open', '');
    } else {
      details.removeAttribute('open');
    }
  };

  toggleDetails.addEventListener('change', toggleDetailsHandler);
  toggleDetailsHandler(toggleDetails);

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      setActiveTab(tab.id);
    });
  });

  setActiveTab(tabId || tabs[0].id);
})();
